<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'set-point'"
    @hidden="$emit('onCloseModal')"
  >
    <template #modal-header>
      <div class="head-label d-flex justify-content-between align-items-center">
        <div>
          <icon-star class="mr-2" />{{
            dataModal.isTypeReward == 2 ? "กำหนดแต้ม" : "Set Reward"
          }}
        </div>
        <div class="d-flex" v-if="dataModal.isTypeReward == 2">
          <div class="card-condition-point">
            <span class="text-condition-point"
              >สมาชิก<b>{{
                !dataModal.formData.isEqual
                  ? "ได้แต้มไม่เท่ากัน"
                  : "ได้แต้มเท่ากัน"
              }}</b></span
            >
          </div>
          <div class="card-set-point text-black">{{ resolveText }}</div>
        </div>
      </div>
    </template>
    <div :class="{ 'overflow-set-point': dataModal.formData.isEqual != true }">
      <b-row class="mb-2 ml-2" v-if="dataModal.isTypeReward == 1">
        <b-col>
          <label for="select-inventory" class="font-medium-3 text-black">
            <span class="required"> Choose Inventory </span>
          </label>
          <v-select
            v-model="dataModal.formData.selectInventory"
            class="vselect-linehight select-format-container bg-dropdown"
            :class="
              dataModal.formData.selectInventory
                ? 'select-format-selected'
                : null
            "
            placeholder="Master Inventory "
            :reduce="(option) => option.value"
            :options="optionsInventory"
            :clearable="false"
            @input="
              inputPrivilegeInventory(dataModal.formData.selectInventory, false)
            "
          />
        </b-col>
      </b-row>
      <b-row
        v-for="(item, index) in permissionOption"
        :key="index + 'id'"
        class="text-black"
        :class="dataModal.formData.isEqual == true ? 'mb-0' : 'mb-2'"
      >
        <div
          class="d-flex align-item-center"
          :class="dataModal.isTypeReward == 2 ? 'col-8' : 'col-7'"
          v-if="dataModal.formData.isEqual == false"
        >
          <div class="mr-2">{{ index + 1 }}.</div>
          <div class="name-tag">{{ item.label }}</div>
        </div>
        <div
          class="d-flex align-item-center"
          :class="dataModal.isTypeReward == 2 ? 'col-8' : 'col-7'"
          v-else
        >
          <div class="mr-2" :class="index != 0 ? 'd-none' : ''">
            {{ index + 1 }}.
          </div>
          <div class="name-tag" :class="index != 0 ? 'd-none' : ''">
            {{ "All tag" }}
          </div>
        </div>

        <div
          :class="dataModal.isTypeReward == 2 ? 'col-4' : 'col-5 pl-0'"
          class=""
        >
          <div
            v-if="
              dataModal.isTypeReward == 2 && dataModal.formData.isEqual == false
            "
          >
            <input-spin-quiz
              :isText="'แต้ม'"
              :numValue="item.point"
              :isInputDisabled="false"
              @update-number="updateNumSpinPoint($event, index)"
            />
          </div>
          <div
            v-else-if="
              dataModal.isTypeReward == 2 && dataModal.formData.isEqual == true
            "
            :class="index != 0 ? 'd-none' : ''"
          >
            <input-spin-quiz
              :isText="'แต้ม'"
              :numValue="item.point"
              :isInputDisabled="false"
              @update-number="updateNumSpinPoint($event)"
            />
          </div>

          <div v-else>
            <v-select
              v-model="item.reward"
              class="vselect-linehight select-format-container bg-dropdown text-overflow-reward"
              :class="item.reward ? 'select-format-selected' : null"
              placeholder="กรุณาเลือกของรางวัล *"
              :reduce="(option) => option.value"
              :options="optionsPrivilege"
              :clearable="false"
              @option:selected="onChange(item.reward, index)"
            />
          </div>
        </div>
      </b-row>
    </div>
    <b-row>
      <b-col cols="12">
        <div class="privilege-btn-wrp mt-2 mb-2">
          <div class="d-flex justify-content-center">
            <cancel-button class="mr-1" @click.native="$emit('onCloseModal')" />
            <save-button
              :loading="loading"
              class="ml-1"
              :btnLabel="'Apply'"
              @click.native="onSubmitModal"
              :disabled="isValidate"
            />
          </div>
        </div>
      </b-col>
    </b-row>
  </base-modal>
</template>

<script>
import IconStar from "@/@core/components/svg/common/IconStar.vue";
import {
  ref,
  reactive,
  computed,
  getCurrentInstance,
  onBeforeMount,
  watch,
} from "@vue/composition-api";
import InputSpinQuiz from "@/views/components/input-spin/InputSpinQuiz.vue";

export default {
  components: {
    IconStar,
    InputSpinQuiz,
  },
  props: {
    dataModal: { type: Object, default: {} },
    optionsInventory: { type: Array, default: [] },
    optionsPrivilege: { type: Array, default: [] },
    permissionOption: { type: Array, default: [] },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const resolveText = computed(() => {
      if (props.dataModal.formData.answerSetPoint == 1) {
        return "ตอบถูกทุกข้อ เพื่อรับแต้ม";
      } else if (props.dataModal.formData.answerSetPoint == 2) {
        return "ตอบครบทุกข้อ เพื่อรับแต้ม";
      } else if (props.dataModal.formData.answerSetPoint == 3) {
        return `ตอบถูกอย่างน้อย ${props.dataModal.formData.minimumCorrect} ข้อ`;
      } else if (props.dataModal.formData.answerSetPoint == 4) {
        return "ตอบข้อที่ถูกต้องเท่านั้น ";
      }
    });

    const isValidate = computed(() => {
      if (props.dataModal.isTypeReward == 1) {
        let objs = "";
        props.permissionOption.map((e) => {
          return (objs = e);
        });
        return (
          props.dataModal.formData.selectInventory == null ||
          objs.reward == null
        );
      }
    });

    const updateNumSpinPoint = (number, index) => {
      vm.$emit("updatePointModal", number, index);
    };
    const onSubmitModal = () => {
      vm.$emit("onSubmitForm", props.permissionOption, props.dataModal);
    };

    const inputPrivilegeInventory = (InventoryId, isSelect) => {
      vm.$emit("inputPrivilegeInventory", InventoryId, isSelect);
    };

    const loading = ref(false);

    const onChange = (value, idx) => {
      vm.$nextTick((e) => {
        vm.$emit("onChange", value, idx);
      });
    };

    onBeforeMount(() => {});

    return {
      loading,
      resolveText,
      updateNumSpinPoint,
      onSubmitModal,
      inputPrivilegeInventory,
      onChange,
      isValidate,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/quiz/privilege.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/v-select.css";
</style>

<style>
#set-point .head-label svg {
  width: 17px;
}

#set-point .card-condition-point {
  background-color: rgba(229, 236, 243, 255);
  padding: 0.4rem 2rem;
  border-radius: 0.5rem;
  font-size: 18px;
  margin: 0.4rem 0.3rem;
}

#set-point .text-condition-point {
  color: #09458b;
}

#set-point .text-condition-point b {
  text-decoration-line: underline !important;
}

#set-point .text-black {
  color: #000;
}

#set-point .card-set-point {
  background-color: #f3f3f3;
  padding: 0.4rem 2rem;
  border-radius: 0.5rem;
  font-size: 18px;
  margin: 0.4rem 0.3rem;
}

#set-point .name-tag {
  width: 100%;
  height: 35px;
  background-color: #f3f3f3;
  display: flex;
  align-items: center;
  padding: 0.8rem;
  border-radius: 8px;
  font-size: 14px;
}

#set-point .redeem-limit-container {
  border-radius: 0.8rem;
}

#set-point .bg-dropdown {
  border: 1px solid #728aac !important;
}

#set-point .vs--single .vs__dropdown-toggle {
  height: 35px;
  display: flex;
  align-items: center;
}

#set-point .vs__selected-options.span.vs__selected {
  white-space: nowrap;
  width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
}

#set-point .btn-secondary:disabled {
  background-color: #c7cfce !important;
  border-color: #c7cfce !important;
}

#set-point .vselect-linehight.vs--open .vs__dropdown-toggle {
  border: none;
  background: transparent;
  box-shadow: none;
}

#set-point .vselect-linehight.vs--single .vs__dropdown-toggle {
  padding: 0 6px;
  background: transparent;
  border: none;
}

#set-point .vs__search::placeholder {
  color: #728aac;
  font-size: 1.25rem;
}

#set-point .vs--disabled .vs__search,
.vs--disabled .vs__open-indicator {
  background-color: transparent !important;
}

#set-point
  .v-select.vselect-linehight.redeem-limit-container.bg-dropdown.vs--single.vs--searchable.vs--disabled.redeem-limit-selected {
  border: none !important;
}
#set-point .vs--disabled .vs__dropdown-toggle {
  background: #efefef !important;
}

#set-point .vs__search,
.vs__search:focus {
  margin: 0px !important;
}
</style>

